import { createFileRoute } from "@tanstack/react-router";

import ComingSoonCover from "@/components/ComingSoonCover";

import placeholder from "../_placeholders/-assets/placeholder-alerts.png";

export const Route = createFileRoute("/_staff/licenses/_list/alerts/")({
  component: () => <ComingSoonCover placeholderImage={placeholder} />,
});
